const React = require('react');
const {FormWrapper, FormFooter} = require('../../../../FormHandlers');
const NotificationBlock = require('./components/NotificationBlock');
const BLOCKS_LIST = require('./constants/blocksList');

module.exports = () => {
  return (
    <FormWrapper>
      {(formCtx) => {
        return (
          <>
            {BLOCKS_LIST.map((block, id) => (
              <div key={id} className="mt53">
                <NotificationBlock
                  {...block}
                  formCtx={formCtx}
                />
              </div>
            ))}
            <FormFooter
              submitBtnData={{
                text: 'Save configuration',
                formCtx
              }}
              additionalBtnsList={[
                {text: 'Reset to global'}
              ]}
            />
          </>
        )
      }}
    </FormWrapper>
  )
}
